export default function socialStickyNavInit() {
  var $socialStickyNavClose = $('#social-sticky-toggle-close'),
    $socialStickyNavOpen = $('#social-sticky-toggle-open'),
    isHome = $('.layout-home').length ? true : false,
    scrollDistance = window.innerHeight / 2,
    lastPosition = 0,
    closeSocialStickyNavOnScroll = function () {
      if (Math.abs(lastPosition - window.scrollY) > scrollDistance) {
        $socialStickyNavClose.prop('checked', true).trigger('change');
      }
    };

  if (!isHome) return;

  $(window).on('scroll', function () {
    if ($socialStickyNavOpen.prop('checked') === true) {
      closeSocialStickyNavOnScroll();
    }
  });

  $socialStickyNavOpen.on('click', function () {
    lastPosition = window.scrollY;
  });
}
